<template>
    <apexchart
        width="200"
        height="85"
        type="bar"
        :options="chartDetails.options"
        :series="chartDetails.series"
    ></apexchart>
</template>

<script>
import apexchart from "vue-apexcharts";

export default {
    name: "headerChartBars",
    components: {
        apexchart
    },
    data() {
        return {
            defaultOptions: {
                chart: {
                    type: "bar",
                    stacked: true,
                    toolbar: {
                        show: false
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                xaxis: {
                    labels: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    }
                },
                tooltip: {
                    x: {
                        show: false
                    },
                    y: {
                        formatter: value => parseInt(value)
                    }
                },
                stroke: {
                    width: 1,
                    colors: ["#fff"]
                },
                legend: {
                    show: false
                },
                theme: {
                    palette: "palette6",
                    monochrome: {
                        enabled: false,
                        color: "#255aee",
                        shadeTo: "light",
                        shadeIntensity: 0.65
                    }
                }
            }
        };
    },
    props: {
        cWidth: {
            type: String,
            default: "200"
        },
        cHeight: {
            type: String,
            default: "85"
        },
        cOptions: {
            type: Object
        },
        cSeries: {
            type: Array,
            required: true
        }
    },
    computed: {
        chartDetails() {
            Object.assign(this.defaultOptions, this.cOptions);
            return {
                height: this.cHeight,
                width: this.cWidth,
                options: this.defaultOptions,
                series: this.cSeries
            };
        }
    }
};
</script>